import React from 'react';
import { Accent, SectionHeading } from './SectionHeading';
import { TeachingFlow } from './TeachingFlow';
import { volumeFlow, volumes } from '../../data/content';
export function VolumesSection() {
  return <section aria-labelledby="volumes-heading" className="bg-brand-paper px-5 py-16 lg:px-8 lg:py-24" data-id="element-196" data-mp="3yjtk0xizler">
      <div className="mx-auto max-w-6xl" data-id="element-197" data-mp="80ewtaz0o8v6">
        <SectionHeading id="volumes-heading" title={<>
              Everything Your Barbering Classes Need — <Accent data-id="element-199" data-mp="10okiq11t43wl">In One Place.</Accent>
            </>} data-id="element-198" data-mp="81ga7m3i97g2" />

        <ol className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" role="list" data-id="element-200" data-mp="mwmfu7yov48v">
          {volumes.map(volume => <li key={volume.number} className="flex h-full flex-col overflow-hidden rounded-[20px] bg-white shadow-[0_24px_50px_-36px_rgba(90,70,40,0.45)]" data-id="element-201" data-mp="qxptcnt9ko6x">
              <div className="flex min-h-[170px] flex-col px-6 pb-6 pt-5" style={{
            backgroundColor: volume.accent
          }} data-id="element-202" data-mp="1jf29i032wpfb">
                <span className="self-start rounded-full bg-white/70 px-3 py-1 font-body text-[10px] font-bold uppercase tracking-[0.2em] text-brand-charcoal/75" data-id="element-203" data-mp="cmazsjk0hj23">
                  Volume {volume.number}
                </span>
                <h3 className="mt-auto pt-6 font-display text-[1.45rem] font-bold leading-[1.12] text-brand-charcoal" data-id="element-204" data-mp="mcdque7komxs">
                  {volume.title}
                </h3>
              </div>
              <p className="flex-1 px-6 py-5 text-[14px] leading-relaxed text-brand-charcoal/65" data-id="element-205" data-mp="va699r8lcape">{volume.description}</p>
            </li>)}
        </ol>

        <TeachingFlow steps={volumeFlow} className="mt-12" data-id="element-206" data-mp="15agjr438r40v" />
      </div>
    </section>;
}